'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  flex: 1;\n  height: ', 'px;\n'], ['\n  display: flex;\n  align-items: center;\n  flex: 1;\n  height: ', 'px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n'], ['\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-bottom: 0;\n  font-size: ', ';\n'], ['\n  margin-bottom: 0;\n  font-size: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  font-size: 11px;\n  line-height: initial;\n  padding-top: 5px;\n'], ['\n  font-size: 11px;\n  line-height: initial;\n  padding-top: 5px;\n']);

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UITruncateString = require('UIComponents/text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _Constants = require('ui-addon-avatars/Constants');

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _ChatHeadingAvatars = require('./ChatHeadingAvatars');

var _ChatHeadingAvatars2 = _interopRequireDefault(_ChatHeadingAvatars);

var _getWidgetTitleText = require('../operators/getWidgetTitleText');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BORDER_WIDTH = 2;

var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'WidgetHeaderAvatarWrapper__Wrapper'
})(_templateObject, _Constants.AVATAR_SIZES.sm + BORDER_WIDTH * 2);

var HeaderTextWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'WidgetHeaderAvatarWrapper__HeaderTextWrapper'
})(_templateObject2);

var HeaderName = _styledComponents2.default.h5.withConfig({
  displayName: 'WidgetHeaderAvatarWrapper__HeaderName'
})(_templateObject3, function (props) {
  return props.titleText && props.titleText.length > 20 ? '14px' : null;
});
var AvailabilityMessage = _styledComponents2.default.div.withConfig({
  displayName: 'WidgetHeaderAvatarWrapper__AvailabilityMessage'
})(_templateObject4);

var WidgetHeaderAvatarWrapper = function (_React$PureComponent) {
  _inherits(WidgetHeaderAvatarWrapper, _React$PureComponent);

  function WidgetHeaderAvatarWrapper() {
    _classCallCheck(this, WidgetHeaderAvatarWrapper);

    return _possibleConstructorReturn(this, (WidgetHeaderAvatarWrapper.__proto__ || Object.getPrototypeOf(WidgetHeaderAvatarWrapper)).apply(this, arguments));
  }

  _createClass(WidgetHeaderAvatarWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          availabilityMessage = _props.availabilityMessage,
          chatHeadingConfig = _props.chatHeadingConfig,
          chatHeadingResponders = _props.chatHeadingResponders,
          locale = _props.locale,
          mobile = _props.mobile,
          showAvailabilityMessage = _props.showAvailabilityMessage,
          showStatusIndicator = _props.showStatusIndicator,
          borderColor = _props.borderColor;


      var titleText = (0, _getWidgetTitleText.getWidgetTitleText)(chatHeadingConfig, chatHeadingResponders, locale) || _I18n2.default.text('conversations-visitor-experience-components.default.agent');

      return _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_ChatHeadingAvatars2.default, {
            chatHeadingConfig: chatHeadingConfig,
            chatHeadingResponders: chatHeadingResponders,
            mobile: mobile,
            showStatusIndicator: showStatusIndicator,
            borderColor: borderColor
          })
        ),
        _react2.default.createElement(
          HeaderTextWrapper,
          { className: 'p-x-3' },
          _react2.default.createElement(
            HeaderName,
            { titleText: titleText },
            _react2.default.createElement(
              _UITruncateString2.default,
              null,
              _react2.default.createElement(
                'span',
                { className: 'widget-header-name p-y-0' },
                titleText
              )
            )
          ),
          showAvailabilityMessage && _react2.default.createElement(
            AvailabilityMessage,
            null,
            availabilityMessage
          )
        )
      );
    }
  }]);

  return WidgetHeaderAvatarWrapper;
}(_react2.default.PureComponent);

WidgetHeaderAvatarWrapper.propTypes = {
  availabilityMessage: _react.PropTypes.string,
  borderColor: _react.PropTypes.string.isRequired,
  chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
  chatHeadingResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
  locale: _react.PropTypes.string,
  mobile: _react.PropTypes.bool.isRequired,
  showAvailabilityMessage: _react.PropTypes.bool.isRequired,
  showStatusIndicator: _react.PropTypes.bool.isRequired
};

WidgetHeaderAvatarWrapper.defaultProps = {
  mobile: false,
  showStatusIndicator: false
};

exports.default = WidgetHeaderAvatarWrapper;
module.exports = exports['default'];